import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ResponseNet } from 'src/app/model/ResponseNet.model';
import { jwtDecode,  ResponseUser, User } from 'src/app/model/User.model';
import { AjaxService } from 'src/app/service/ajax.service';
import { AuthService } from 'src/app/service/auth.service';
import { LiveChatService } from 'src/app/service/live-chat-service';
import { UtilService } from 'src/app/service/util.service';
import { API } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  email: string;
  senha: string;
  jwt_decode: jwtDecode;
  user : ResponseUser = new ResponseUser();


  constructor(
    private router: Router,
    private ajax: AjaxService,
    private util: UtilService,
    private auth: AuthService,
    public realTime: LiveChatService
  ) {
    this.user.user = new User();
    this.user.token = "";
   }

  ngOnInit() {
    this.email = '';
    this.senha = '';
  }

  login(){
 
    debugger
    this.router.navigate(['/home']);
    //let url = "https://api.qrcode.lumago.com.br/api/";
    //https://localhost:44308/api/Login/Login?login=diogo%40lumago.com&senha=123456

    //console.log(this.email, this.senha);
    /*this.util.showLoading();
    var url = API + 'Login/Login?login='+this.email+'&senha='+this.senha;
    this.ajax.get(url)
      .subscribe((response: ResponseNet) => {

        this.util.closeLoading();

        this.jwt_decode = this.util.getDecodedAccessToken(response.data.token);
        this.user.user.nome = this.jwt_decode.nameid;
        this.user.token = response.data.token;
        this.user.idEmpresa = response.data.idEmpresa;
        this.user.user.guid_usuario = response.data.usuario.iD_USUARIO;
        this.user.user.guid_empresa = response.data.usuario.iD_EMPRESA;
        this.user.user.guid_atendente = response.data.usuario.iD_ATENDENTE;
        this.user.user.email = response.data.usuario.login;
        this.user.user.perfil = response.data.usuario.perfil;
        this.user.user.telefoneEmpresa = response.data.numeroEmpresa;
        debugger

        this.auth.setUser(this.user);
        this.realTime.initializeNewUserConnectionAsync(this.user);
        this.util.toasterShowSuccess("Sucesso", "Bem Vindo " + this.user.user.nome);
        this.router.navigate(['/home']);
      }, err => {
        debugger
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Usuário ou Senha inválidos");
      });*/

  }

}
